import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';

import { QueryBuilderApp } from '../QueryBuilderApp';

const memberPrimaryKeyTypes = [
  { label: 'MobileNo', value: 'MobileNo' },
  { label: 'Email', value: 'Email' },
  { label: 'country', value: 'country' },
  { label: 'FirstName', value: 'FirstName' },
  { label: 'LastName', value: 'LastName' },
  { label: 'EcommId', value: 'EcommId' },
  { label: 'city', value: 'city' },
  { label: 'region', value: 'region' },
  { label: 'location', value: 'location' },
];

const CouponAdvancedOptions = ({
  setFieldValue,
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
}) => {
  const [isEnableProductEligibility, setIsEnableProductEligibility] =
    useState(false);
  const [isEnableMemberKeyOption, setIsEnableMemberKeyOption] = useState(false);
  const [isEnableRuleEligibility, setIsEnableRuleEligibility] = useState(false);

  useEffect(() => {
    try {
      if (
        values?.memberPrimaryKeyValues?.length > 0 &&
        !isEnableMemberKeyOption
      ) {
        setIsEnableMemberKeyOption(true);
      }

      if (values?.productEligibility?.rule && !isEnableProductEligibility) {
        setIsEnableProductEligibility(true);
      }

      if (values?.ruleEligibility?.rule && !isEnableRuleEligibility) {
        setIsEnableRuleEligibility(true);
      }
    } catch (e) {
      console.log(e);
    }
  }, [values]);

  return (
    <div>
      <div className="d-flex flex-column">
        <FormGroup>
          <div className="form-check form-switch form-switch-custom form-switch-dark d-flex gap-2 align-items-center p-0">
            <Label className="form-check-label" htmlFor="isUseLauncherConfig">
              Enable Member filter
            </Label>
            <Input
              type="checkbox"
              className="form-check-input m-0"
              id="isUseLauncherConfig"
              onChange={() =>
                setIsEnableMemberKeyOption(!isEnableMemberKeyOption)
              }
              checked={isEnableMemberKeyOption}
            />
          </div>
        </FormGroup>
        {isEnableMemberKeyOption ? (
          <div className="border border-1 rounded-3 px-3 pt-3 mb-3">
            <FormGroup className="col-5">
              <Label for="memberPrimaryKeyType">Member primary key type</Label>
              <Input
                type="select"
                id="memberPrimaryKeyType"
                name="memberPrimaryKeyType"
                value={values?.memberPrimaryKeyType}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={
                  touched?.memberPrimaryKeyType && errors?.memberPrimaryKeyType
                }
              >
                {memberPrimaryKeyTypes?.map((item) => (
                  <option key={item?.value} value={item?.value}>
                    {item?.label}
                  </option>
                ))}
              </Input>
              <FormFeedback>{errors?.memberPrimaryKeyType}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="memberPrimaryKeyValues">
                Member primary key values
              </Label>
              <Input
                id="memberPrimaryKeyValues"
                name="memberPrimaryKeyValues"
                type="textarea"
                value={values?.memberPrimaryKeyValues}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={
                  touched?.memberPrimaryKeyValues &&
                  errors?.memberPrimaryKeyValues
                }
              />
              <FormFeedback>{errors?.memberPrimaryKeyValues}</FormFeedback>
            </FormGroup>
          </div>
        ) : null}

        <FormGroup>
          <div className="form-check form-switch form-switch-custom form-switch-dark d-flex gap-2 align-items-center p-0">
            <Label className="form-check-label" htmlFor="isUseLauncherConfig">
              Click here for Rule Eligibility
            </Label>
            <Input
              type="checkbox"
              className="form-check-input m-0"
              id="isUseLauncherConfig"
              onChange={() =>
                setIsEnableRuleEligibility(!isEnableRuleEligibility)
              }
              checked={isEnableRuleEligibility}
            />
          </div>
        </FormGroup>

        {isEnableRuleEligibility ? (
          <div className="border border-1 rounded-3 px-3 pt-3 mb-3">
            <FormGroup>
              <Label for="ruleEligibility">Rule Eligibility</Label>
              <QueryBuilderApp
                updateQuery={(query) =>
                  setFieldValue('ruleEligibility', { rule: query })
                }
                data={values?.ruleEligibility?.rule}
                fieldGroups={['member', 'basket']}
              />
            </FormGroup>

            <FormGroup className="d-flex align-items-center">
              <Label for="isOnlyUseCouponRuleEligibility" className="me-2 mb-0">
                Is only use coupon rule eligibility
              </Label>
              <div className="form-switch">
                <Input
                  type="switch"
                  name="isOnlyUseCouponRuleEligibility"
                  id="isOnlyUseCouponRuleEligibility"
                  checked={values?.isOnlyUseCouponRuleEligibility}
                  onChange={handleChange}
                />
              </div>
            </FormGroup>
          </div>
        ) : null}

        <FormGroup>
          <div className="form-check form-switch form-switch-custom form-switch-dark d-flex gap-2 align-items-center p-0">
            <Label className="form-check-label" htmlFor="isUseLauncherConfig">
              Enable Product Eligibility
            </Label>
            <Input
              type="checkbox"
              className="form-check-input m-0"
              id="isUseLauncherConfig"
              onChange={() =>
                setIsEnableProductEligibility(!isEnableProductEligibility)
              }
              checked={isEnableProductEligibility}
            />
          </div>
        </FormGroup>

        {isEnableProductEligibility ? (
          <div className="border border-1 rounded-3 px-3 pt-3 mb-3">
            <FormGroup>
              <Label for="productEligibility">Product Eligibility</Label>
              <QueryBuilderApp
                updateQuery={(query) =>
                  setFieldValue('productEligibility', { rule: query })
                }
                data={values?.productEligibility?.rule}
                fieldGroups={['item']}
              />
            </FormGroup>

            <FormGroup className="d-flex align-items-center">
              <Label
                for="isOnlyUseCouponProductEligibility"
                className="me-2 mb-0"
              >
                Is only use coupon product eligibility
              </Label>
              <div className="form-switch">
                <Input
                  type="switch"
                  name="isOnlyUseCouponProductEligibility"
                  id="isOnlyUseCouponProductEligibility"
                  checked={values?.isOnlyUseCouponProductEligibility}
                  onChange={handleChange}
                />
              </div>
            </FormGroup>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CouponAdvancedOptions;
